export const AUTH_FLOW_PURPOSE_KEY = "auth_flow_purpose";
export const AUTH_FLOW_PURPOSE_PASSWORD_RESET = "PASSWORD_RESET";
export const AUTH_FLOW_PURPOSE_RESET_TOTP = "RESET_TOTP";
export const AUTH_FLOW_PURPOSE_LOGIN = "LOGIN";

// Set when the password-reset flow is entered from the (already authenticated)
// Settings > Change Password action, rather than the logged-out "forgot
// password" link. Purely a frontend UI flag — the OTP purpose sent to the
// backend stays AUTH_FLOW_PURPOSE_PASSWORD_RESET either way; this only
// controls whether SetupPassword shows/requires the Current Password field.
export const AUTH_FLOW_CHANGE_PASSWORD_CONTEXT_KEY =
  "auth_flow_change_password_context";
